import * as Types from '../../graphql.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RequestLoginCodeMutationVariables = Types.Exact<{
  email: Types.Scalars['String']['input'];
}>;


export type RequestLoginCodeMutation = { requestLoginCode: boolean };


export const RequestLoginCodeDocument = gql`
    mutation RequestLoginCode($email: String!) {
  requestLoginCode(email: $email)
}
    `;
export type RequestLoginCodeMutationFn = Apollo.MutationFunction<RequestLoginCodeMutation, RequestLoginCodeMutationVariables>;

/**
 * __useRequestLoginCodeMutation__
 *
 * To run a mutation, you first call `useRequestLoginCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestLoginCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestLoginCodeMutation, { data, loading, error }] = useRequestLoginCodeMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRequestLoginCodeMutation(baseOptions?: Apollo.MutationHookOptions<RequestLoginCodeMutation, RequestLoginCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestLoginCodeMutation, RequestLoginCodeMutationVariables>(RequestLoginCodeDocument, options);
      }
export type RequestLoginCodeMutationHookResult = ReturnType<typeof useRequestLoginCodeMutation>;
export type RequestLoginCodeMutationResult = Apollo.MutationResult<RequestLoginCodeMutation>;
export type RequestLoginCodeMutationOptions = Apollo.BaseMutationOptions<RequestLoginCodeMutation, RequestLoginCodeMutationVariables>;